export default "__VITE_ASSET__94f8e35a__"